














import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import Default from '../components/common/Default.vue'
import { isDevMode } from '../lib/appHelper'
import UserCard from '../components/pages/home/UserCard.vue'
import { Page, UserSearchFormParams } from '../type'
import LoadingModal from '../components/common/LoadingModal.vue'
import UserDetailDialog from '../components/pages/home/UserDetailDialog.vue'
import UserFilterDialog from '../components/pages/home/UserFilterDialog.vue'
import { MutationSetSearchParams } from '../store/app/types'
import UserSearchForm from '../components/common/UserSearchForm.vue'

const AppModule = namespace('app')

@Component({
  components: {
    Default,
    LoadingModal,
    UserCard,
    UserDetailDialog,
    UserFilterDialog,
    UserSearchForm
  }
})
export default class Home extends Vue {
  @AppModule.Mutation('setSearchParams')
  setSearchParams!: MutationSetSearchParams

  get isDevMode() {
    return isDevMode
  }

  handleSubmit(params: UserSearchFormParams) {
    this.setSearchParams(params)
    this.$router.push({ name: Page.Users })
  }
}
